import React from 'react'
import ReactDOM from 'react-dom'
import { Provider } from 'react-redux'
import store from './store.js'
import './bootstrap.min.css'
import './styles/theme.css'
import './index.css'
import App from './App'
import reportWebVitals from './reportWebVitals'

navigator.serviceWorker.register('./serviceworker.js')

ReactDOM.render(
  <Provider store={store}>
    <App />
  </Provider>,
  document.getElementById('root')
)

reportWebVitals()
